var graph =
{
    svg: null,
    width: 940,
    height: 800,
    ratio: null,
    routes: [],
    catrouteID: null,
    locationID: null,
    points: [],
    margin: {
        top: 35,
        right: 190,
        bottom: 42,
        left: 90
    },
    color_in: '#ff0000',
    color_out: '#ff0000',

    init: function(locationID, width, height, widthMM, margin, color_in, color_out) {
        graph.width = width;
        graph.height = height;
        graph.widthMM = widthMM;
// graph.ratio = 0.264583 / 0.96; //DPI = 96
        graph.ratio = (graph.width - graph.margin.right - graph.margin.left) / widthMM;
        graph.svg = d3.select("#drawing");
        graph.locationID = locationID;
        graph.margin = margin;
        graph.color_in = color_in;
        graph.color_out = color_out;

        graph.drawRules();

        $.post('/cat/graph/getCatRoutePoints/' + graph.locationID, {}, function(resp){
            if(resp) {
                $.each(resp, function(index, obj){
                    graph.points.push({
                        "id": obj.catroutepointID,
                        "r": obj.catroutepoint_r,
                        "cx": obj.catroutepoint_x,
                        "cy": obj.catroutepoint_y,
                        "name": obj.catroutepoint_name
                    });
                });

                graph.drawPoints();
                graph.bezierCurvesInit();
            }
        }, 'json');
    },


    mouseover: function() {
        var group = $(this),
            id = group.data('id')
            ;

        if(!group.hasClass('select')) {
            $('.circle-group:not(.select)').each(function(index, obj){
                var circleGroup = $(obj),
                    groupID = circleGroup.data('id'),
                    circle = circleGroup.find('circle');

                if(groupID == id) {
                    circle.css('fill-opacity', 1.0);
                    d3.selectAll('.path[data-from="' + id + '"], .path[data-to="' + id + '"]').style('stroke-opacity', '1.0');
                } else {
                    circle.css('fill-opacity', 0.3);
                    d3.selectAll('.path[data-from="' + groupID + '"]:not([data-to="' + id + '"]), .path[data-to="' + groupID + '"]:not([data-from="' + id + '"])').style('stroke-opacity', '0.3');
                }
            });
        }
    },
    mouseout: function() {
        var group = $(this),
            id = group.data('id')
            ;

        if(!group.hasClass('select')) {
            $('.circle-group:not(.select)').each(function(index, obj){
                var circleGroup = $(obj),
                    circle = circleGroup.find('circle');

                circle.css('fill-opacity', 0.6);
                d3.selectAll('.path[data-from="' + id + '"], .path[data-to="' + id + '"]').style('stroke-opacity', '0.3');
            });
        }
    },

    selectPoint: function() {
        var group = $(this);

        if(group.hasClass('select')) {
            group
                .removeClass('select')
                .removeClass('from')
                .removeClass('to')
            ;
        } else {
            if($('.circle-group.select').length < 2) {
                group.addClass('select');

                if($('.select.from').length > 0) {
                    group.addClass('to');
                } else {
                    group.addClass('from');
                }
            }
        }

        if($('.circle-group.select').length == 2) {
            $('#add-route-btn').show('fast');
        } else {
            $('#add-route-btn').hide('fast');
        }
    },


    drawRules: function() {
        new rules(
            graph.width,
            graph.height,
            graph.margin
        );
    },


    mmToPixel: function(mm) {
        return mm * graph.ratio;
    },

    pixelToMM: function(pixel) {
        return pixel / graph.ratio;
    },

    coordsToMM: function(xPX, yPX, rPX) {
        return {
            x: graph.pixelToMM(xPX),
            y: graph.pixelToMM(graph.height - yPX - graph.margin.bottom * 2),
            r: graph.pixelToMM(rPX),
        };
    },

    coordsToMMImport: function(xPX, yPX) {
        return {
            x: graph.pixelToMM(xPX + graph.margin.left),
            y: graph.pixelToMM(graph.height - yPX - graph.margin.bottom * 2 + graph.margin.top)
        };
    },

    coordsToPixel: function(mmX, mmY, mmR) {
        return {
            x: graph.mmToPixel(mmX),
            y: (graph.height - (graph.mmToPixel(mmY) + graph.margin.bottom * 2)),
            r: graph.mmToPixel(mmR),
        };
    },

    drawPoints: function() {
        var length = graph.points.length,
            points = graph.svg.insert('svg:g', 'g.rules')
            .attr('class', 'points')
            .attr('transform', 'translate(' + this.margin.left + ',' + graph.margin.top + ')')
            .attr('width', graph.width - graph.margin.left - graph.margin.right)
            .attr('height', graph.height - graph.margin.top - graph.margin.bottom)
            ;


        for(var i=0; i<length; i++)
        {
            var point = graph.points[i],
                pointGroup;

            if (parseFloat(point.r) > 0.0)
            {
                if(typeof(point.cx) != 'undefined' && typeof(point.cy) != 'undefined')
                {
                    pointGroup = points.append("svg:g")
                        .attr("id", "point_" + point.id + "_group")
                        .attr('data-id', point.id)
                        .attr('data-name', point.name)
                        .attr('class', 'circle-group')
                        .on("mouseover", graph.mouseover)
                        .on("mouseout", graph.mouseout)
                        .on('click', graph.selectPoint)
                    ;

                    var position = graph.coordsToPixel(point.cx, point.cy, point.r);

                    pointGroup
                        .append("svg:circle")
                        .attr("cx", position.x)
                        .attr("cy", position.y)
                        .attr("r", position.r)
                        .style("stroke-width", position.r * 0.2)
                        .attr("id", "point_" + point.id)
                        .attr('class', 'node')
                    ;

                    pointGroup.append('svg:text')
                        .attr('x', position.x)
                        .attr('y', position.y - (position.r + 3))
                        .text(point.name)
                        .attr('class', 'to-center label')
                    ;
                }
            }
        }

        $('.circle-group').find('text').attr('x', function(){ return ($(this).attr('x') - $(this).width() / 2) })
    },

    addControlPoint: function(pathID) {
        var pathID = pathID || 0;
    },

    bezierCurvesInit: function()
    {
        $.post('/cat/graph/getCatRoutePositions/' + graph.locationID, {}, function(resp){
            if(resp) {
                $.each(resp, function(index, obj){
                    var myBezierCurves = new bezierCurves(graph.svg, obj);
                    myBezierCurves.catrouteID = index;

                    graph.routes.push(myBezierCurves);
                    myBezierCurves.init();
                });
            }
        }, 'json');
    },

    bezierTools: function() {
        var button = $('.cat-bezier-tools-btn'),
            text = button.find('.text');

        if(button.hasClass('btn-system')) {
            button.removeClass('btn-system').addClass('btn-danger');
            text.html('Hide tools');
            text.removeClass('fa-toggle-on').addClass('fa-toggle-off');
        } else {
            button.removeClass('btn-danger').addClass('btn-system');
            text.html('Show tools');
            text.removeClass('fa-toggle-off').addClass('fa-toggle-on');
        }

        $('.control-tools').toggle();
    },

    rulesTools: function() {
        var button = $('.cat-rules-tools-btn'),
            text = button.find('.text');

        if(button.hasClass('btn-system')) {
            button.removeClass('btn-system').addClass('btn-danger');
            text.html('Hide rulers');
            text.removeClass('fa-toggle-on').addClass('fa-toggle-off');
        } else {
            button.removeClass('btn-danger').addClass('btn-system');
            text.html('Show rulers');
            text.removeClass('fa-toggle-off').addClass('fa-toggle-on');
        }

        $('.rules').toggle();
    },

    labelsTools: function() {
        var button = $('.cat-labels-tools-btn'),
            text = button.find('.text');

        if(button.hasClass('btn-system')) {
            button.removeClass('btn-system').addClass('btn-danger');
            text.html('Hide labels');
            text.removeClass('fa-toggle-on').addClass('fa-toggle-off');
        } else {
            button.removeClass('btn-danger').addClass('btn-system');
            text.html('Show labels');
            text.removeClass('fa-toggle-off').addClass('fa-toggle-on');
        }

        $('text.label').toggle();
    },


    removePoint: function(catroutepositionID) {
        popup(trans('Are you sure you want to remove this point?'), trans('Confirmation')).confirm(true, function(result) {
            if (result) {
                $.post('/cat/graph/removePoint/' + catroutepositionID, {}, function () {
                    location.reload();
                });
            }
        });
    },


    selectRoute: function(catrouteID) {
        graph.catrouteID = catrouteID;

        $('g.route').removeClass('select');
        $('g.route[data-catrouteid="' + catrouteID + '"]').addClass('select');

        d3.selectAll("g.route:not(.select)").select('path.curve')
            .attr('marker-end', 'url(#arrow-transparent)');

        d3.selectAll("g.route.select").select('path.curve')
            .attr('marker-end', 'url(#arrow)');



        $('.route-points-row').each(function(index, obj){
            var self = $(obj)
            catrouteDataID = self.data('catrouteid');

            if(catrouteDataID == catrouteID) {
                if(self.css('display') == 'none') {
                    self.show('fast');
                } else {
                    self.hide('fast');
                }
            } else {
                self.hide('fast');
            }
        });
    },


    addPoint: function(catrouteID) {
        graph.catrouteID;
        $('#drawing').addClass('add');
    },

    deleteRoute: function(catrouteID) {
        popup(trans('Are you sure you want to remove this route?'), trans('Confirm: Remove Route - ' + catrouteID)).confirm(true, function(result) {
            if (result) {
                $.post('/cat/graph/deleteRoute/' + catrouteID, {}, function(){
                    location.reload();
                });
            }
        });
    },

    copyRoute: function(catrouteID) {
        $.post('/cat/graph/copyRoute/' + catrouteID, {}, function(){
            location.reload();
        });
    },

    addRoutePopup: function() {
        if($('.circle-group.select').length == 2) {
            var
                groupA = $($('.circle-group.select.from')),
                groupB = $($('.circle-group.select.to')),
                params = {
                    catroutepointAID: groupA.data('id'),
                    catroutepointBID: groupB.data('id'),
                    catroutepointA_name: groupA.data('name'),
                    catroutepointB_name: groupB.data('name'),
                };

            $.post('/cat/graph/addRoutePopup', params, function(resp){
                popup(resp, 'Add route').dialog();
            });
        }
    },

    addRoute: function() {
        var params = {
            catroutepointAID: $('#cat-add-route-form').find('#catroutepointAID').data('id'),
            catroutepointBID: $('#cat-add-route-form').find('#catroutepointBID').data('id'),
            catroutepointA_name: $('#cat-add-route-form').find('#catroutepointAID').data('name'),
            catroutepointB_name: $('#cat-add-route-form').find('#catroutepointBID').data('name'),
            points: $('#cat-add-route-form').find('#points').val(),
            pair: $('#cat-add-route-form').find('#pair').prop('checked') ? 1 : 0,
            catroute_direction: $('#cat-add-route-form').find('#catroute_direction').val(),
        };

        $.post('/cat/graph/addRoute', params, function(){
            location.reload();
        });
    },

    selectControlPoint: function(catRoutePositionID) {
        $('g.control-tools circle').removeClass('select');
        $('g.control-tools circle[data-catroutepositionid="' + catRoutePositionID + '"]').addClass('select');
    },

    exportJs: function() {
        $('.cat-export-tools-btn i').toggle('fast');

        $.post('/cat/graph/exportJs/' + graph.locationID, {}, function(){
            $('.cat-export-tools-btn i').toggle('fast');
        });
    },

    direction: function(catrouteID) {
        $.post('/cat/graph/direction/' + catrouteID, {}, function(resp) {
            popup(resp, 'Change route direction(color)').dialog();
        });
    },

    changeDirection: function(catrouteID) {
        var params = {
            catroute_direction: $('#cat-route-direction-form #catroute_direction').val()
        };

        $('.direction-flip-btn i').toggle('fast');

        $.post('/cat/graph/changeDirection/' + catrouteID, params, function(){
            location.reload();
        });
    },

    selectNode: function(catroutepointID) {
        var event = new MouseEvent('click');

        document.getElementById('point_' + catroutepointID + '_group').dispatchEvent(event);
    },

    removeNode: function(catroutepointID) {
        popup(trans('Are you sure you want to remove this node?'), trans('Confirm: Remove node')).confirm(true, function(result) {
            if (result) {
                $.post('/cat/graph/removeNode/' + catroutepointID, {}, function(){
                    location.reload();
                });
            }
        });
    },
    addNode: function() {
        $('#drawing').addClass('add-node');
    },
    saveNodePoint: function() {
        var params = $('form#cat-add-node-point-form input').serializeObj();

        $('.add-node-point-btn i').toggle('fast')

        $.post('/cat/graph/saveNodePoint', params, function(){
            location.reload()
        }).fail(function(resp) {
            utils.error(resp.responseJSON, 'cat-add-node-point-form');
            $('.add-node-point-btn i').toggle('fast')
        });
    },
};